export const addEventListeners = (element, events, listener) => {
  ("string" === typeof events ? events.split(" ") : events).forEach(event =>
    element.addEventListener(event, listener, false)
  );
};

export default {
  addEventListeners
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/util/events.js